type DescriptorType = 'ISSUE' | 'COLUMN';

export const ISSUE: DescriptorType = 'ISSUE';
export const COLUMN: DescriptorType = 'COLUMN';
